<template>
   <div class="csmar-box">
       <!-- <div class="margin-box"></div> -->
       <img src="../assets/img/csmar.png" alt="">
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.csmar-box {
    width:100%;
    height: 100%;
    overflow-y: scroll;
    padding-top: 0.88rem;
    background-color: #fff;
    .margin-box {
        width: 100%;
        height: 0.2rem;
        background: #eee;
    }
    img {
        width:100%;
    }
}

</style>